import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase/client';

const ProtectedRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                // Check if user is authenticated
                const { data: { user } } = await supabase.auth.getUser();

                if (!user) {
                    navigate('/login');
                    return;
                }

                // Check if user has admin role
                const { data: profile, error } = await supabase
                    .from('users')
                    .select('role, Active')
                    .eq('id', user.id)
                    .single();

                if (error || !profile || profile.role !== 'admin' || !profile.Active) {
                    await supabase.auth.signOut();
                    navigate('/login');
                    return;
                }

                setIsAuthorized(true);
            } catch (error) {
                console.error('Auth check error:', error);
                navigate('/login');
            } finally {
                setLoading(false);
            }
        };

        checkAuth();

        // Set up auth state listener for real-time protection
        const { data: { subscription } } = supabase.auth.onAuthStateChange(
            async (event, session) => {
                if (event === 'SIGNED_OUT') {
                    navigate('/login');
                }

                if (event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') {
                    await checkAuth();
                }
            }
        );

        return () => subscription.unsubscribe();
    }, [navigate]);

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner">Verifying access...</div>
            </div>
        );
    }

    return isAuthorized ? children : null;
};

export default ProtectedRoute;